import { Pipe, PipeTransform } from '@angular/core';

import { PortalTierEnum } from '@app/services/api/api.types';

@Pipe({
  name: 'getCoverage',
})
export class GetCoveragePipe implements PipeTransform {
  transform(pricePerPassenger: number, tier: PortalTierEnum = PortalTierEnum.VIP) {
    if (!pricePerPassenger) return 0;

    const range = rangesConfig.find(
      ({ min, max }) => pricePerPassenger >= min && pricePerPassenger <= max,
    );

    if (!range) return 0;

    switch (tier) {
      case PortalTierEnum.EXECUTIVE:
        return range.executiveValue;
      case PortalTierEnum.ESSENTIAL:
        return range.essentialValue;
      default:
        return range.value;
    }
  }
}

const rangesConfig: {
  min: number;
  max: number;
  value: number;
  executiveValue: number;
  essentialValue: number;
}[] = [
  { min: 0, max: 1500, value: 500, executiveValue: 750, essentialValue: 250 },
  { min: 1501, max: 3000, value: 750, executiveValue: 1000, essentialValue: 500 },
  { min: 3001, max: 4500, value: 1000, executiveValue: 1500, essentialValue: 750 },
  { min: 4501, max: 6000, value: 1250, executiveValue: 1750, essentialValue: 1000 },
  { min: 6001, max: 7500, value: 1500, executiveValue: 2000, essentialValue: 1250 },
  { min: 7501, max: 9000, value: 1750, executiveValue: 2250, essentialValue: 1500 },
  { min: 9001, max: Infinity, value: 2000, executiveValue: 2500, essentialValue: 1750 },
];
